// packages/client/src/components/project/miller/StatusBadge.tsx

const STATUS_CONFIG: Record<string, { label: string; icon: string; color: string }> = {
  DRAFT: { label: 'Draft', icon: '○', color: 'var(--text-muted)' },
  SUBMITTED: { label: 'Submitted', icon: '⟳', color: 'var(--blue)' },
  IN_REVIEW: { label: 'In Review', icon: '⟳', color: 'var(--blue)' },
  APPROVED: { label: 'Approved', icon: '✓', color: 'var(--green)' },
  REVISE: { label: 'Revise', icon: '✗', color: 'var(--red)' },
};

interface StatusBadgeProps {
  status: string;
  compact?: boolean;
}

export default function StatusBadge({ status, compact = false }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.DRAFT;

  if (compact) {
    return (
      <span style={{ color: config.color }} title={config.label}>
        {config.icon}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded"
      style={{
        color: config.color,
        backgroundColor: `color-mix(in srgb, ${config.color} 10%, transparent)`,
      }}
    >
      {config.icon} {config.label}
    </span>
  );
}

// Rollup badge for sets: shows approved/total
export function SetStatusBadge({ approved, total }: { approved: number; total: number }) {
  if (total === 0) return <StatusBadge status="DRAFT" compact />;
  if (approved === total) return <span style={{ color: 'var(--green)' }} title="All approved">●</span>;
  if (approved > 0) return <span style={{ color: 'var(--yellow)' }} title={`${approved}/${total} approved`}>◐</span>;
  return <span style={{ color: 'var(--text-muted)' }} title="Draft">○</span>;
}
